{
  "NLAMS" : [
    {
      "name" : "Loodswezen",
      "portAuthorityId" : "RLC"
    }
  ],
  "NLDHR" : [
    {
      "name" : "Nederlands Loodswezen B.V. North",
      "portAuthorityId" : "LRN"
    }
  ],
  "NLDZL" : [
    {
      "name" : "Nederlands Loodswezen B.V. North",
      "portAuthorityId" : "LWN"
    }
  ],
  "NLHAR" : [
    {
      "name" : "Nederlands Loodswezen B.V. North",
      "portAuthorityId" : "LOODSNORTH"
    }
  ],
  "NLRTM" : [
    {
      "name" : "Loodswezen",
      "portAuthorityId" : "LRR"
    }
  ],
  "NLSCE" : [
    {
      "name" : "Loodswezen",
      "portAuthorityId" : "LRR"
    }
  ],
  "NLTNZ": [
    {
      "name": "Loodswezen",
      "portAuthorityId" : "LWS"
    }
  ],
  "NLVLI": [
    {
      "name": "Loodswezen",
      "portAuthorityId" : "LWS"
    }
  ]
}
